import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { NomenclatureGroupFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-group-find.dto';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NomenclatureGroupService extends BaseService {
  protected baseUrl = '/basis/catalog/nomenclature/group';

  public restoreOne(id: number): Observable<NomenclatureGroupFindInterface> {
    return this.http.post<NomenclatureGroupFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getHistoryForOne(id: number, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }
}
